/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Immobilienscout24Inputs */

const cs_enum_immobilienscout24 = /** @type {(inputs: Enum_Immobilienscout24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ImmobilienScout24`)
};

const en_enum_immobilienscout24 = /** @type {(inputs: Enum_Immobilienscout24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ImmobilienScout24`)
};

/**
* | output |
* | --- |
* | "ImmobilienScout24" |
*
* @param {Enum_Immobilienscout24Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_immobilienscout24 = /** @type {((inputs?: Enum_Immobilienscout24Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Immobilienscout24Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_immobilienscout24(inputs)
	return cs_enum_immobilienscout24(inputs)
});